import React, {useState, useEffect} from 'react';
import {Context} from '../../../../context';
import {
  cardPaymentMethodExists,
  paymentMethodExpiredStyling
} from '../../../../helperFunctions';
import {Switch} from '@mui/material/';

const AutoRenewSection = props => {
  const {account, localeText, loading} = React.useContext(Context);
  const [checked, setChecked] = useState(false);
  const {
    autoRenewEnabled,
    fareProduct,
    toggleAutoRenew,
    changeBillingProfile,
    billingProfile,
    idKey
  } = props;

  const toggleHandler = async () => {
    await toggleAutoRenew(fareProduct);
    setChecked(autoRenewEnabled(fareProduct) ? true : false);
  };

  const paymentSelectHandler = async event => {
    await changeBillingProfile(event, fareProduct);
  };

  useEffect(() => {
    setChecked(autoRenewEnabled(fareProduct));
  }, [account, fareProduct]);

  return (
    <div className='pr-4 flex flex-row gap-6'>
      <div className='flex items-center'>
        <div>
          <Switch
            name='manage_cards_label_auto_renew_checkbox'
            className={`${
              loading || !cardPaymentMethodExists(account)
                ? 'pointer-events-none'
                : ''
            }`}
            id={`toggler-${idKey}`}
            checked={checked}
            onClick={() => toggleHandler(fareProduct)}
          />
        </div>
        <label
          htmlFor='manage_cards_label_auto_renew_checkbox'
          className={`ml-4 ${!checked && 'opacity-50'}`}
          data-testid='manage_cards_label_auto_renew_checkbox'
        >
          {localeText('rw_enable_auto_replenish', 'Enable auto replenish')}
        </label>
      </div>
      <select
        className={`p-4 border rounded-md ${
          !checked && 'opacity-0 pointer-events-none'
        }`}
        onChange={event => paymentSelectHandler(event)}
        defaultValue={billingProfile(fareProduct)?.id}
      >
        {account.paymentMethods
          .filter(pm => pm.processor !== 'STORED_VALUE')
          .map(pm => (
            <option
              key={pm.id}
              value={pm.id}
              className={paymentMethodExpiredStyling(pm)}
            >
              {`${pm.nickname} ****${pm.accountNumber}`}
              &nbsp;&nbsp;
              {` ${localeText('rw_paymentcards_text_exp', 'exp')} ${
                pm.expirationMonth
              }/${pm.expirationYear}`}
            </option>
          ))}
      </select>
    </div>
  );
};

export default AutoRenewSection;
